
import { Col, Row } from "vant";

export default {
  components: {
    [Col.name]: Col,
    [Row.name]: Row,
  },
};
